import { TranslateModule } from "@ngx-translate/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { Component, TemplateRef, computed, inject, viewChild } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";

import { AuthService, customValidations, LookupsService, Tab } from "src/app/core";
import { InputTextComponent, ButtonComponent, TabsComponent, InputTextDropdownComponent } from "src/app/shared";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-forget-password",
  standalone: true,
  imports: [
    RouterLink,
    TranslateModule,
    ReactiveFormsModule,
    InputTextComponent,
    ButtonComponent,
    TabsComponent,
    InputTextDropdownComponent,
  ],
  templateUrl: "./forget-password.component.html",
  styleUrl: "./forget-password.component.scss",
})
export class ForgetPasswordComponent {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private authService = inject(AuthService);
  private activatedRoute = inject(ActivatedRoute);
  private lookupsService = inject(LookupsService);

  forgetPasswordForm!: FormGroup;
  forgetPasswordTabs: Tab[] = [];
  countries = toSignal(this.lookupsService.getCountries(), { initialValue: [] });

  currentPhoneCountryCode = computed(() => {
    return "+968";

    // const countryCode = window.navigator.language.split("-").pop();
    // const country = this.countries().find((c) => c.code === countryCode);

    // if (!country) return null;
    // return country.phoneCode as string;
  });

  readonly byEmailTab = viewChild.required<TemplateRef<unknown>>("byEmailTab");
  readonly byPhoneTab = viewChild.required<TemplateRef<unknown>>("byPhoneTab");

  get isForgetByPhone() {
    return this.forgetPasswordForm.get("type")?.value === 2;
  }

  get token() {
    return this.activatedRoute.snapshot.queryParamMap.get("token") || null;
  }

  get phoneCountryCode() {
    if (!this.countries().length && !this.forgetPasswordForm.get("countryCode")?.value) return null;

    const country = this.countries().find((c) => c.phoneCode === this.forgetPasswordForm.get("countryCode")?.value);

    if (!country) return null;
    return country.code;
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.token) {
      this.router.navigate(["email"], { relativeTo: this.activatedRoute, queryParamsHandling: "merge" });
    }

    this.forgetPasswordTabs = [
      {
        key: "email",
        title: "AUTH.BYEMAIL",
        template: this.byEmailTab(),
      },
      {
        key: "phone",
        title: "AUTH.BYMOBILE",
        template: this.byPhoneTab(),
      },
    ];

    this.initForm();
  }

  initForm() {
    this.forgetPasswordForm = this.fb.group({
      email: [null, [Validators.required, customValidations.email()]],
      phone: [{ value: null, disabled: true }, [Validators.required]],
      countryCode: [{ value: null, disabled: true }, [Validators.required]],
      type: [1],
    });
  }

  getActiveTab(event: number) {
    switch (event) {
      case 0:
        this.forgetPasswordForm.get("type")?.setValue(1);
        this.forgetPasswordForm.get("phone")?.disable();
        this.forgetPasswordForm.get("phoneCcountryCodeode")?.disable();
        this.forgetPasswordForm.get("email")?.enable();
        break;
      case 1:
        this.forgetPasswordForm.get("type")?.setValue(2);
        this.forgetPasswordForm.get("email")?.disable();
        this.forgetPasswordForm.get("phone")?.enable();
        this.forgetPasswordForm.get("countryCode")?.enable();
        break;
      default:
        break;
    }
  }

  getPhoneCountryCode(countryCode: string | number | boolean) {
    const country = this.countries().find((c) => c.phoneCode === countryCode);

    if (country) {
      const countryPhoneRegex = (country as any).phoneCodeRegex;

      this.forgetPasswordForm
        .get("phone")
        ?.setValidators([Validators.required, customValidations.withCustomMobileNumberRegex(countryPhoneRegex)]);
    }
  }

  forget() {
    let payload = this.forgetPasswordForm.value;
    if (payload.phone && payload.countryCode) payload.phone = `${+payload.phone}`;

    this.authService.resetPassword(this.forgetPasswordForm.value).subscribe(() => {
      if (this.isForgetByPhone) {
        localStorage.setItem("phone", this.forgetPasswordForm.value.phone);
        localStorage.setItem("countryCode", this.forgetPasswordForm.value.countryCode);
        this.router.navigate(["otp"], { relativeTo: this.activatedRoute });
        return;
      } else {
        this.router.navigate(["/auth/login"]);
      }
    });
  }
}
